module.exports = __webpack_public_path__ + "static/media/interest-sme.467e1837.svg";